import { YouTube } from './YouTube'
import { SoundCloud } from './SoundCloud'
import { Vimeo } from './Vimeo'
import { Facebook } from './Facebook'
import { Streamable } from './Streamable'
import { Wistia } from './Wistia'
import { Twitch } from './Twitch'
import { DailyMotion } from './DailyMotion'
import { Mixcloud } from './Mixcloud'
import { FilePlayer } from './FilePlayer'

export default [
  YouTube,
  SoundCloud,
  Vimeo,
  Facebook,
  Streamable,
  Wistia,
  Twitch,
  DailyMotion,
  Mixcloud,
  FilePlayer
]
